import React from 'react'
import { Link } from 'react-router-dom';
import MetaGroup from '../components/meta-group';
import { Container } from 'react-bootstrap';
import HeroFull from '../assets/images/home-hero.png';
import GetDemo from '../components/CTAs/GetDemo';
import { setProspect } from '../helpers/cookies';
import IntegrationFeature from '../components/integrations-feature';

class Home extends React.Component {
	render() {
		let referrer = document.referrer;
		return (
			<div>
				<MetaGroup
					title="Rossware | Appliance Repair Software"
					metaDescription="The best field service management software tools for businesses of all sizes. Rossware builds software solutions to help field service businesses to optimize their workflow and improve their bottom line. A perfect product for Appliance Repair, HVAC repair, Garage door repair, plumbing, electricians, and more."
					ogImage="%PUBLIC_URL%/logo512.png"
					canonical=""
				/>
				<div className="section">
					<div className="container-md">
						<h1 className="text-center display-1 mb-4">Appliance repair software trusted by service companies for decades</h1>
						<p className="lead text-center mb-5">Streamline scheduling, dispatch, payments, and warranty claims — all in one complete system built for growing appliance service companies like yours.</p>
						<div className="text-center mb-5">
							<Link className="btn btn-primary mr-4" to="/demo" onClick={() => setProspect(referrer, 'home_demo')}>Request a demo</Link>
							<Link className="btn btn-outline-primary" to="/contact">Contact Sales</Link>
						</div>
						<img src={HeroFull} alt="ServiceDesk on an Laptop" width="100%" className="border rounded shadow-sm" />

					</div>
				</div>

				<IntegrationFeature />

				<div className="section">
					<Container className="grid-3-col text-center">
						<div>
							<h5>Scheduling &amp; Dispatch</h5>
							<p className="mb-5 text-muted">Say goodbye to sticky notes. Our software provides input, tracking, messaging, and associated processing for every incoming call as it transitions from a call into a scheduled job.</p>
						</div>
						<div>
							<h5>Job Management</h5>
							<p className="mb-5 text-muted">Manage your customers, keep track of current jobs, view job statuses, and customer history.</p>
						</div>
						<div>
							<h5>Map View</h5>
							<p className="mb-5 text-muted">With a custom map of your specific service territory you can see the relative geographic locations, and time, for each job, with every technician's route geographically displayed and color coded.</p>
						</div>
						<div>
							<h5>Planner View</h5>
							<p className="mb-5 text-muted">View your schedule on a planner view, similar to a calendar, to get an easy at a glance view of your technician's days.</p>
						</div>
						<div>
							<h5>Inventory Management</h5>
							<p className="mb-5 text-muted">Manage your desired inventory, your current stocked parts, see unique items in your inventory, and special order parts for certain jobs.</p>
						</div>
						<div>
							<h5>Technician Mobile App</h5>
							<p className="mb-5 text-muted">iOS and Android apps for your techs that provide them with everything they need to excel at their job and communicate with the office.</p>
						</div>
						<div>
							<h5>Estimates</h5>
							<p className="mb-5 text-muted">Easily provide estimates to your customers for work, and convert them into jobs.</p>
						</div>
						<div>
							<h5>Invoicing</h5>
							<p className="mb-5 text-muted">Save time and money with our custom digital invoices containing your business's name, logo, and colors that are sent to your customers.</p>
						</div>
						<div>
							<h5>Online booking</h5>
							<p className="mb-5 text-muted">Your customers can access an online scheduler that embeds right in your website that can show your live availability by zone.</p>
						</div>
					</Container>
				</div>

				<section className="">
					<div className="container">
						<div className="grid-2-col md-gap">
							<div className="feature-text">
								<div className="grid-rows">
									<h3 className="">Software born from the service industry</h3>
									<p>Rossware's ServiceDesk software was created with real-world experience to solve the unique challenges of appliance repair businesses:</p>
									<ul>
										<li><p><strong>Industry-built</strong> — Designed from the ground up by an appliance repair company owner.</p></li>
										<li><p><strong>Problem-focused</strong> — Crafted to solve the everyday challenges service companies face.</p></li>
										<li><p><strong>Advantage-driven</strong> — Tools to help your business stand out from the competition.</p></li>
									</ul>
									<Link className="btn btn-primary" to="/features/">Explore Rossware</Link>
								</div>
							</div>
							<div className="widget-zone">
								<img src="https://cdn.buttercms.com/vOoiEfjcTrC1do9ka3so" width="100%" alt="Call management with Call Sheets" className="widget"></img>
							</div>
						</div>
						<div className="grid-2-col md-gap py-6">
							<div className="widget-zone">
								<img src="https://cdn.buttercms.com/UajLoBc4SRS9bg5HQ6qz" width="100%" alt="Call management with Call Sheets" className="widget"></img>
							</div>
							<div className="grid-rows">
								<h3 className="">Customized for your company</h3>
								<p className="">ServiceDesk comes with custom-built elements that make the software more efficient and specific to your territory:</p>
								<ul>
									<li><p><strong>Custom Dispatch Map</strong> — See routes, job sites, and technician locations in real time.</p></li>
									<li><p><strong>Territory-Specific Data</strong> — Autofills local streets and areas unique to your service region.</p></li>
									<li><p><strong>Time-Saving Automation</strong> — Location info auto-populates across the software as you work.</p></li>
								</ul>
								<Link className="btn btn-primary" to="/features/">Explore Rossware</Link>
							</div>

						</div>
					</div>

					<div className="section">
						<Container>
							<div className="grid-2-col lg-gap">
								<div className="grid-rows">
									<h3 className="">Empower your technicians in the field</h3>
									<p className="">Your techs can see their jobs, clock in and out, leave descriptions of work done, request orders for parts, schedule future jobs, invoice and take payment in the field, and more!</p>
									<ul class="custom-bullets">
										<li><p><strong>Job Management</strong> — View schedules, job details, and track progress in real time.</p></li>
										<li><p><strong>On-the-Go Efficiency</strong> — Clock in/out, record work notes, and request parts directly from the field.</p></li>
										<li><p><strong>Faster Payments</strong> — Create invoices and process payments on-site.</p></li>
									</ul>
									<Link className="btn btn-primary" to="/features/">Explore Rossware</Link>
								</div>
								<div className="text-center">
									<img src="https://cdn.buttercms.com/ssxSB9dQwGySBRYtQdgH" width="100%" alt="Appliance repair technician working on a washing machine." className="shadow-hard border rounded"></img>
								</div>
							</div>
						</Container>
					</div>
				</section>

				<GetDemo light />
			</div>

		)
	}
}
export default Home;